// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Cancel Payment</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>Are you sure you want to cancel this payment?</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="deleteScheduleNoButton"
                    id="deleteScheduleNoButton"
                    class="Button Button--link Button--minWidth130" (click)="closeThisDialog(0)">
                No
            </button>
            <button tid="deleteScheduleYesButton"
                    id="deleteScheduleYesButton"
                    class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog('Delete')">
                Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;